'use client';

import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const HeroSection = () => {
  return (
    <section className="relative h-[600px] md:h-[700px] lg:h-[800px] overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=1920&q=80)'
        }} />

        
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex items-center">
        <div className="max-w-5xl space-y-6 md:space-y-8">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-header font-bold text-white leading-tight">
            Food Today, <br />Futures Tomorrow
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-body text-white leading-relaxed drop-shadow-[0_0_24px_rgba(255,255,255,0.6)] [text-shadow:0_0_40px_rgba(255,255,255,0.5),0_0_80px_rgba(255,255,255,0.2),0_2px_6px_rgba(0,0,0,0.7)] tracking-wide">We equip students to lead, succeed, and drive real-world impact in STEM education, food and nutrition, and the interdisciplinary solutions shaping our future.

          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/initiatives"
              className="inline-flex items-center justify-center px-8 py-4 bg-brand-primary text-brand-primary-foreground font-header font-semibold text-base rounded-lg hover:bg-brand-primary/90 hover:shadow-brand-md hover:-translate-y-1 transition-all duration-300">

              Explore Programs
              <Icon name="ArrowRightIcon" size={20} className="ml-2" />
            </a>
            <Link
              href="https://forms.gle/JAnAQKxV7VuoBwnGA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-header font-semibold text-base rounded-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300">

              Get Involved
            </Link>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;